/* eslint-disable @typescript-eslint/no-empty-function */
import React, { createContext, useContext, useState } from 'react';

import { SecuritySettingModalNames } from '@/components/SecuritySettingModalManager';

const ModalContext = createContext({
  showSecuritySettingModalName: '' as SecuritySettingModalNames | '',
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  openSecuritySettingModal: (name: SecuritySettingModalNames) => {},
  closeSecuritySettingModal: () => {},
});

export const SecuritySettingModalProvider = ({
  children,
}: {
  children: any;
}) => {
  const [showSecuritySettingModalName, setShowSecuritySettingModalName] =
    useState<SecuritySettingModalNames | ''>('');

  const openSecuritySettingModal = (modalName: SecuritySettingModalNames) => {
    setShowSecuritySettingModalName(modalName);
  };

  const closeSecuritySettingModal = () => {
    setShowSecuritySettingModalName('');
  };

  return (
    <ModalContext.Provider
      value={{
        showSecuritySettingModalName,
        openSecuritySettingModal,
        closeSecuritySettingModal,
      }}
    >
      {children}
    </ModalContext.Provider>
  );
};

export const useSecuritySettingModal = () => useContext(ModalContext);
